import TableComponent from "../../../components/organism/Table/TableComponent";
import { FC, useMemo } from "react";
import { Column } from "react-table";
import FieldOccurencesState from "../../FieldOccurrences/component/FieldOccurencesState";
import AlertSanLevelState from "../../FieldOccurrences/AlertSan/AlertSanLevelState";

interface TableOccurrencesAlertSanProps {
  dataTable: any[];
  isLoaded: boolean;
}

const TableOccurrencesAlertSan: FC<TableOccurrencesAlertSanProps> = ({
  dataTable,
  isLoaded,
}) => {
  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "Título", accessor: "title", disableSortBy: true },
      {
        Header: "Indicadores",
        accessor: "occurrences",
        disableSortBy: true,
        Cell: ({ row }: any) => {
          const occurrences = row.original.occurrences;
          if (!Array.isArray(occurrences) || occurrences.length === 0) {
            return <>-</>;
          }

          const indicatorNames = occurrences
            .map((occurrence: any) => occurrence?.indicator?.name)
            .filter((name: string | undefined) => name);
          const uniqueIndicatorNames = Array.from(new Set(indicatorNames));
          return uniqueIndicatorNames.length > 0 ? (
            <>{uniqueIndicatorNames.join(", ")}</>
          ) : (
            <>-</>
          );
        },
      },
      {
        Header: "Período",
        accessor: "dataPeriod.name",
      },
      {
        Header: "Ano",
        accessor: "year",
      },
      {
        Header: "Nível do Alerta",
        accessor: "alertSeverity.name",
        Cell: ({ row }: any) => {
          return (
            <AlertSanLevelState
              stateValue={row.original.alertSeverity}
              additionalStyle={{ display: "inline-block" }}
              hasBackground={false}
            />
          );
        },
      },
      {
        Header: "Estado",
        accessor: "isActive",
        Cell: ({ row, value }: any) => {
          return (
            <FieldOccurencesState
              stateValue={
                row.original.type?.code?.toLowerCase() === "alertasan"
                  ? value
                  : null
              }
              additionalStyle={{ display: "inline-block" }}
              hasBackground={false}
            />
          );
        },
      },
    ];

    return baseColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTable]);

  return (
    <TableComponent isLoaded={isLoaded} columns={columns} data={dataTable} />
  );
};

export default TableOccurrencesAlertSan;
